module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-07-3cbb6d8a194f3284f762f030c5b35d5a.jpg";